import getRequest from 'utils/getRequest'

const path = '/api/iucn-items'

//eslint-disable-next-line
export const requestIUCNListSearch = (scientificName, filterSearch, excludeId, signal) => {
  const url = filterSearch ? `${path}?scientificName=${scientificName}&select=scientific_name,taxonid&excludeId=${excludeId.toString()}&limit=6` : `${path}?scientificName=${scientificName}&limit=5`
  return getRequest(url, signal)
}
